import BaseModule from '@core/modules/base-module/base-module';

// IMPORT COMPONENTS
import FaqAccordion from '@core/components/accordions/faq-accordion/faq-accordion';


  const faqsGroup=new BaseModule();
  faqsGroup.name='faqs-group';
  faqsGroup.init((that)=> {
    const faqAccordion = new FaqAccordion();
    faqAccordion.init();
  });


